import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'shalala';
import { Button, Row, Col } from 'react-bootstrap';

import { useStore } from '../../../store';
import Loading from '../../../facturotopia/loading/Loading';
import LoadingButton from '../../../facturotopia/LoadingButton';
import ResponseError from '../../../shared/responses/ResponseError';
import PopConfirm from '../../../facturotopia/popconfirm/PopConfirm';
import ResponseResult from '../../../shared/responses/ResponseResult';
import ReceptorFiscalInfoForm from '../../../app/receptores/upsert/components/ReceptorFiscalInfoForm';
import ReceptorFiscalAddressForm from '../../../app/receptores/upsert/components/ReceptorFiscalAddressForm';

class ClienteBillingInfo extends Component {
  steps = [
    {
      number: 1,
      key: 'fiscal-info',
      done: false,
    },
    {
      number: 2,
      key: 'fiscal-address',
      done: true,
    },
  ];

  constructor(props) {
    super(props);

    const { data = {} } = props;

    const newData = {
      data: { ...data },
      steps: [...this.steps],
    };

    props.setPartialState(newData);
  }

  componentWillUnmount() {
    this.props.reset();
  }

  handleOnAction = (action: string) => {
    if (action === 'reset') {
      this.props.setPartialState({
        error: undefined,
      });

      return;
    }

    if (action === 'cancel') {
      return;
    }

    const { data } = this.props.billing;

    this.props.onComplete(action === 'success' ? data : null);
  };

  handleOnConfirm = async () => {
    const { data } = this.props.billing;
    const keys = Object.keys(data);

    let info = {};

    for (const key of keys) {
      if (data[key] !== null) {
        info[key] = data[key];
      }
    }

    const body = {
      ...info,
    };

    delete body.id;

    await this.props.upsert(body, data.id);

    const { result, error } = this.props.billing;

    if (!error && !!result && !!this.props.onComplete) {
      this.props.onComplete(result.data);
    }
  };

  handleOnDataChange = (event) => {
    this.props.setPartialState(event);
  };

  handleOnFiscalAddressDataChange = (event) => {
    let data = {
      ...this.props.data,
      direccion: event.data,
    };

    this.props.setPartialState({
      ...event,
      data,
    });
  };

  renderError = () => {
    const { error } = this.props.billing;

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={error}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  renderResult = () => {
    const { result, data } = this.props.billing;

    return (
      <div className="result-container">
        <ResponseResult
          title={data.id ? 'Información actualizada' : 'Registro completado'}
          result={result}
          onAction={this.handleOnAction}
        />
      </div>
    );
  };

  render() {
    const { data = {}, steps = [], error, result, isValid, busy, fetching } = this.props.billing;

    if (fetching || steps.length === 0) {
      return <Loading />;
    }

    return (
      <>
        {!!error && this.renderError()}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">INFORMACIÓN FISCAL</strong>
            </div>

            <ReceptorFiscalInfoForm
              data={data}
              step={steps[0]}
              autoFocus={true}
              history={this.props.history}
              onFormDataChange={this.handleOnDataChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <div className="py-3">
              <strong className="text-info">DOMICILIO FISCAL</strong>
            </div>

            <ReceptorFiscalAddressForm
              data={data.direccion || {}}
              step={steps[1]}
              onFormDataChange={this.handleOnFiscalAddressDataChange}
            />
          </Col>
        </Row>

        {!!result && (
          <Row>
            <Col>
              <p className="text-info">
                Actualizado por última vez a las {moment(result.data.updated_at).format('hh:mm:ss A')}
              </p>
            </Col>
          </Row>
        )}

        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <PopConfirm
              text="Realmente deseas cancelar?"
              onAction={this.handleOnAction}
            >
              <Button
                type="button"
                variant="secondary"
                disabled={busy}
              >
                Cancelar
              </Button>
            </PopConfirm>{' '}
            <LoadingButton
              type="button"
              disabled={!isValid}
              loading={busy || false}
              onClick={this.handleOnConfirm}
            >
              {!!data.id ? (busy ? 'Actualizando...' : 'Guardar') : ''}
              {!data.id ? (busy ? 'Guardando...' : 'Guardar') : ''}
            </LoadingButton>
          </Col>
        </Row>
      </>
    );
  }
}

const mapState = (store) => {
  return { billing: store.admin.clientes.billing };
};

const mapActions = (actions) => {
  return actions.admin.clientes.billing;
};

export default connect(useStore, mapState, mapActions)(ClienteBillingInfo);
